import React, {useEffect} from 'react';
import useApi from "../../hooks/useApi";
import ILegendeCouleur from "../../models/ILegendeCouleur";

const CalendrierLegende = () => {
    const {data: reservationCouleurs, getData: getReservationCouleur} = useApi<ILegendeCouleur[]>("reservationCouleur");

    useEffect(() => {
        getReservationCouleur({customPath: "reservationCouleur/GetLegendeCouleurCalendrier"});
    }, [])

    return (
        <div>
            <div>
                {reservationCouleurs?.map((couleur) => {
                    return (
                        <div key={`legende-couleur-${couleur.descriptionFrancaise}`} style={{backgroundColor: couleur.couleurBackground, textAlign: "center", color: couleur.couleurTexte}}>{couleur.descriptionFrancaise}</div>)
                })}
            </div>
        </div>
    )
}
export default CalendrierLegende;